import React from 'react';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import PropTypes from 'prop-types';

const DashboardWidgetWrapper = (props) => {
	const { children, label } = props;

	const IconStyle = (theme) => ({ marginRight: theme.spacing() });

	return (
		<Stack margin={1}>
			<Paper>
				<Stack direction="row" flexWrap="wrap" margin={2}>
					<Stack justifyContent="center">
						<PostAddOutlinedIcon sx={IconStyle} />
					</Stack>
					<Typography variant="h6">{label}</Typography>
				</Stack>
				<Stack>{children}</Stack>
			</Paper>
		</Stack>
	);
};

DashboardWidgetWrapper.propTypes = {
	children: PropTypes.any,
	label: PropTypes.string
};

export default DashboardWidgetWrapper;
